import React from "react";
import { Box, BoxProps } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { useField, FieldInputProps, FieldMetaProps, FieldHelperProps } from "formik";

interface FormFieldProps {
  name: string;
  containerProps?: ContainerProps;
  children: React.ReactElement | React.ReactElement[];
}

type ContainerProps = Partial<BoxProps>;
const defaultContainerProps: ContainerProps = {};

export const FormFieldContext = React.createContext<FormFieldContextProps | null>(null);

export interface FormFieldContextProps {
  field: FieldInputProps<any>;
  meta: FieldMetaProps<any>;
  helpers: FieldHelperProps<any>;
}

export const FormField = ({ name, children, containerProps = {} }: FormFieldProps) => {
  const mergedContainerProps = deepmerge(defaultContainerProps, containerProps);
  const [field, meta, helpers] = useField(name);

  return (
    <FormFieldContext.Provider value={{ field, meta, helpers }}>
      <Box {...mergedContainerProps}>{children}</Box>
    </FormFieldContext.Provider>
  );
};
